import { forwardRef } from 'react';
import { Field, FieldProps } from 'formik';
import { JItem } from '../jformik/jformik.types';
import { InfoCard } from '../../availability';

export const FInfoCard = forwardRef((jItem: JItem, ref) => {
  const { name, label } = jItem;

  return (
    <Field name={name} innerRef>
      {({ field: { name, value }, form: { values } }: FieldProps) => {
        return <InfoCard key={name} title={label} value={value} />;
      }}
    </Field>
  );
});
